module.exports = __webpack_public_path__ + "img/table3.c43b1132.png";